var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlayBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 135 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a6a6a6;}.cls-10,.cls-2,.cls-3{fill:#fff;}.cls-2{stroke:#fff;stroke-miterlimit:10;stroke-width:0.2px;}.cls-4{fill:url(#Unbenannter_Verlauf);}.cls-5{fill:url(#Unbenannter_Verlauf_2);}.cls-6{fill:url(#Unbenannter_Verlauf_3);}.cls-7{fill:url(#Unbenannter_Verlauf_4);}.cls-8{opacity:0.2;}.cls-10,.cls-8,.cls-9{isolation:isolate;}.cls-9{opacity:0.12;}.cls-10{opacity:0.25;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf",
    x1: 21.8,
    y1: 1966.71,
    x2: 5.02,
    y2: 1983.49,
    gradientTransform: "translate(0 -1958)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_2",
    x1: 33.83,
    y1: 1978,
    x2: 9.64,
    y2: 1978,
    gradientTransform: "translate(0 -1958)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_3",
    x1: 24.83,
    y1: 1980.3,
    x2: 2.07,
    y2: 2003.05,
    gradientTransform: "translate(0 -1958)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_4",
    x1: 7.3,
    y1: 1958.18,
    x2: 17.46,
    y2: 1968.34,
    gradientTransform: "translate(0 -1958)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 40,
    rx: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130,.8A4.2,4.2,0,0,1,134.2,5V35a4.2,4.2,0,0,1-4.2,4.2H5A4.2,4.2,0,0,1,.8,35h0V5A4.2,4.2,0,0,1,5,.8H130m0-.8H5A5,5,0,0,0,0,5V35a5,5,0,0,0,5,5H130a5,5,0,0,0,5-5V5A5,5,0,0,0,130,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.42,10.24a2.75,2.75,0,0,1-.75,2,2.88,2.88,0,0,1-2.2.89,3.15,3.15,0,0,1-2.21-5.37,3,3,0,0,1,2.21-.9,3.08,3.08,0,0,1,1.23.25,2.61,2.61,0,0,1,.94.67l-.53.53a2,2,0,0,0-1.64-.71,2.32,2.32,0,0,0-2.33,2.31V10a2.36,2.36,0,0,0,4,1.73,1.85,1.85,0,0,0,.5-1.22H44.47V9.79h2.91A2.28,2.28,0,0,1,47.42,10.24ZM52,7.74H49.3v1.9h2.46v.72H49.3v1.9H52V13H48.5V7H52ZM55.28,13h-.77V7.74H52.83V7H57v.74H55.28Zm4.66,0V7h.77v6Zm4.19,0h-.77V7.74H61.68V7H65.8v.74H64.13Zm9.48-.78a3.12,3.12,0,0,1-4.4,0,3.24,3.24,0,0,1,0-4.45,3.1,3.1,0,0,1,4.38,0l0,0A3.24,3.24,0,0,1,73.61,12.22Zm-3.83-.5a2.31,2.31,0,0,0,3.26,0,2.55,2.55,0,0,0,0-3.44,2.31,2.31,0,0,0-3.26,0A2.55,2.55,0,0,0,69.78,11.72ZM75.58,13V7h.94l2.92,4.67V7h.77v6h-.8l-3-4.89V13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M68.14,21.75A4.25,4.25,0,1,0,72.41,26a4.19,4.19,0,0,0-4.13-4.25Zm0,6.83a2.58,2.58,0,1,1,2.39-2.75.91.91,0,0,1,0,.17,2.46,2.46,0,0,1-2.34,2.58Zm-9.31-6.83A4.25,4.25,0,1,0,63.09,26,4.19,4.19,0,0,0,59,21.75h-.13Zm0,6.83a2.58,2.58,0,1,1,2.38-2.76,1.09,1.09,0,0,1,0,.18,2.46,2.46,0,0,1-2.34,2.58h-.05ZM47.74,23.06v1.8h4.32a3.77,3.77,0,0,1-1,2.27,4.41,4.41,0,0,1-3.33,1.32,4.8,4.8,0,1,1,0-9.6A4.58,4.58,0,0,1,51,20.14l1.27-1.27A6.32,6.32,0,0,0,47.74,17a6.61,6.61,0,0,0-.51,13.21h.51a5.84,5.84,0,0,0,6.17-6.07,6.09,6.09,0,0,0-.1-1.13Zm45.31,1.4a3.92,3.92,0,0,0-7.65,1.28,2.26,2.26,0,0,0,0,.26,4.16,4.16,0,0,0,4.07,4.25h.15a4.23,4.23,0,0,0,3.54-1.88l-1.45-1a2.44,2.44,0,0,1-2.09,1.18,2.17,2.17,0,0,1-2.06-1.29l5.69-2.35Zm-5.8,1.42a2.34,2.34,0,0,1,2.17-2.48h0a1.65,1.65,0,0,1,1.58.9ZM82.63,30H84.5V17.5H82.63Zm-3.06-7.3H79.5a3,3,0,0,0-2.24-1,4.26,4.26,0,0,0,0,8.51,2.9,2.9,0,0,0,2.24-1h.06v.61c0,1.63-.87,2.5-2.27,2.5a2.35,2.35,0,0,1-2.14-1.51l-1.63.68A4,4,0,0,0,77.29,34c2.19,0,4-1.29,4-4.43V22H79.57Zm-2.14,5.88a2.59,2.59,0,0,1,0-5.16,2.4,2.4,0,0,1,2.27,2.52V26a2.38,2.38,0,0,1-2.17,2.57h-.1ZM101.81,17.5H97.34V30h1.87V25.26h2.61a3.89,3.89,0,1,0,.56-7.76,5.23,5.23,0,0,0-.56,0Zm0,6H99.2V19.24h2.65a2.15,2.15,0,0,1,0,4.29Zm11.53-1.8A3.51,3.51,0,0,0,110,23.61l1.66.69a1.75,1.75,0,0,1,1.7-.92,1.8,1.8,0,0,1,2,1.58v.16a4.14,4.14,0,0,0-2-.48c-1.79,0-3.6,1-3.6,2.81a2.88,2.88,0,0,0,3,2.75h.08a2.62,2.62,0,0,0,2.4-1.2h.06v1h1.8V25.19c0-2.19-1.66-3.46-3.79-3.46Zm-.23,6.85c-.61,0-1.46-.31-1.46-1.06,0-1,1.06-1.33,2-1.33a3.38,3.38,0,0,1,1.7.42,2.26,2.26,0,0,1-2.19,2ZM123.74,22l-2.14,5.42h-.06L119.32,22h-2l3.33,7.58-1.9,4.21h2L125.82,22Zm-16.81,8h1.87V17.5h-1.87Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.44,7.54A2,2,0,0,0,10,8.94V31.06a2,2,0,0,0,.46,1.4l.07.07L22.9,20.15v-.29L10.51,7.47Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M27,24.28l-4.1-4.13v-.29L27,15.72l.09,0L32,18.56c1.4.79,1.4,2.09,0,2.89l-4.89,2.78Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M27.12,24.22,22.9,20,10.44,32.46a1.63,1.63,0,0,0,2.08.06l14.61-8.3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M27.12,15.78,12.51,7.48a1.63,1.63,0,0,0-2.08.06L22.9,20Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M27,24.13,12.51,32.38a1.68,1.68,0,0,1-2,0l-.07.07.07.07a1.65,1.65,0,0,0,2,0l14.61-8.3Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M10.44,32.32a2,2,0,0,1-.46-1.4v.15a2,2,0,0,0,.46,1.4l.07-.07ZM32,21.3l-5,2.83.09.09L32,21.44A1.75,1.75,0,0,0,33,20,1.86,1.86,0,0,1,32,21.3Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M12.51,7.62,32,18.7A1.86,1.86,0,0,1,33,20a1.75,1.75,0,0,0-1-1.44L12.51,7.48C11.11,6.69,10,7.35,10,9V9.1C10,7.49,11.12,6.83,12.51,7.62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBadge);
export default __webpack_public_path__ + "static/media/google-play-badge.17171dcc5aa9fc85480665445914f40d.svg";
export { ForwardRef as ReactComponent };